module.exports = __webpack_public_path__ + "static/dual_20_amp_relay_companion_module-0404ec8c2349f4622867f7e89e6e37d9.png";